var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistorricon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.212,
    height: 21.196,
    viewBox: "0 0 23.212 21.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_85859",
    x: 0,
    y: 0,
    width: 23.212,
    height: 21.196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3110",
    "data-name": "Group 3110",
    transform: "translate(-284 -135.297)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85859-2",
    "data-name": "Path 85859",
    d: "M19.872,21.271a4.162,4.162,0,0,0,.559-.86c1.021-2.092,1.021-15.517,0-17.609a4.169,4.169,0,0,0-.559-.86C17.676-.665,3.681-.616,1.3,1.9a3.488,3.488,0,0,0-.6.876c-.928,1.9-.928,15.757,0,17.662a3.492,3.492,0,0,0,.6.876c2.382,2.515,16.378,2.564,18.574-.041Z",
    transform: "translate(307.212 135.297) rotate(90)",
    fill: "#feed00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 284, 135.3)",
    filter: "url(#Path_85859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85859-3",
    "data-name": "Path 85859",
    d: "M19.872,21.271a4.162,4.162,0,0,0,.559-.86c1.021-2.092,1.021-15.517,0-17.609a4.169,4.169,0,0,0-.559-.86C17.676-.665,3.681-.616,1.3,1.9a3.488,3.488,0,0,0-.6.876c-.928,1.9-.928,15.757,0,17.662a3.492,3.492,0,0,0,.6.876c2.382,2.515,16.378,2.564,18.574-.041Z",
    transform: "translate(23.21) rotate(90)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_85250",
    "data-name": "Path 85250",
    d: "M87.141,33.4v2.936h4.48V33.4a1.383,1.383,0,0,1,.282-.943.952.952,0,0,1,.745-.315.981.981,0,0,1,.756.311,1.336,1.336,0,0,1,.291.946v8.07a1.347,1.347,0,0,1-.293.95.985.985,0,0,1-.754.315.943.943,0,0,1-.748-.317,1.4,1.4,0,0,1-.279-.948V38.021h-4.48v3.446a1.356,1.356,0,0,1-.293.95.989.989,0,0,1-.756.315.945.945,0,0,1-.748-.317,1.4,1.4,0,0,1-.279-.948V33.4a1.394,1.394,0,0,1,.277-.943.943.943,0,0,1,.75-.315.985.985,0,0,1,.757.311A1.351,1.351,0,0,1,87.141,33.4Z",
    transform: "translate(206.226 108.158)",
    fill: "#0094d9",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorricon);
export default __webpack_public_path__ + "static/media/historricon.305b2a95a875529b597ac94115a7e253.svg";
export { ForwardRef as ReactComponent };